export default "__VITE_ASSET__Df2N_GZO__"